// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "home-footer {\n  font-size: 13px !important;\n  font-weight: 400 !important;\n}\nhome-footer a {\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = exports;
